module.exports = __webpack_public_path__ + "img/空白（底图+文字+页码）.a5f51940.jpg";